import { useForm } from "@inertiajs/react";
import InertiaLink from "@/components/buttons/InertiaLink";
import Button from "@/components/buttons/Button";
import Input from "@/components/inputs/Input";
import React from "react";
import FormActions from "@/components/buttons/FormActions";

interface UserEditProps {
  user: {
    email: string;
    first_name: string;
    last_name: string;
  };
}

const Edit: React.FC<UserEditProps> = ({ user }) => {
  const { data, setData, put, processing, errors } = useForm({
    email: user.email,
    first_name: user.first_name,
    last_name: user.last_name,
    password: "",
    password_confirmation: "",
    current_password: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    put("/users", {
      onError: () => {
        setData("current_password", "");
      },
    });
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex w-full flex-col items-start justify-start gap-8 rounded-lg md:p-10"
    >
      <h1 className="font-serif text-2xl font-bold lg:text-4xl">Settings</h1>
      <Input
        type="text"
        value={data.email}
        onChange={(e) => setData("email", e.target.value)}
        placeholder="Email"
        errors={errors.email}
        label="Email"
      />
      <Input
        type="text"
        value={data.first_name}
        onChange={(e) => setData("first_name", e.target.value)}
        placeholder="First Name"
        errors={errors.first_name}
        label="First Name"
      />
      <Input
        type="text"
        value={data.last_name}
        onChange={(e) => setData("last_name", e.target.value)}
        placeholder="Last Name"
        errors={errors.last_name}
        label="Last Name"
      />
      <Input
        type="password"
        value={data.password}
        onChange={(e) => setData("password", e.target.value)}
        placeholder="Password (leave blank if you don't want to change it)"
        errors={errors.password}
        label="Password"
      />
      <Input
        type="password"
        value={data.password_confirmation}
        onChange={(e) => setData("password_confirmation", e.target.value)}
        placeholder="Password Confirmation"
        errors={errors.password_confirmation}
        label="Password Confirmation"
      />
      <Input
        type="password"
        value={data.current_password}
        onChange={(e) => setData("current_password", e.target.value)}
        placeholder="Current Password (required to confirm changes)"
        errors={errors.current_password}
        label="Current Password"
      />

      <FormActions>
        <InertiaLink href="/" type="secondary" text="Cancel" />
        <Button type="primary" text="Save" disabled={processing} />
      </FormActions>
    </form>
  );
};

export default Edit;
